import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import QuitFlowModalContainer from 'common/modals/QuitFlowModalContainer';
import ScriptFlowHeader from 'common/ScriptFlowHeader';
import ScriptFlowBody from 'common/ScriptFlowBody';
import MessagePanel from 'messages/MessagePanel';

import ExperimentPlanContainer from './ExperimentPlanContainer';
import TrialPlacementsContainer from './TrialPlacementsContainer';

const steps = {
  1: ExperimentPlanContainer,
  2: TrialPlacementsContainer,
  3: TrialPlacementsContainer
};

const TrialScript = ({
  canGoBack,
  canGoForward,
  closeMessage,
  initialLoadIsInProgress,
  isAppMode,
  isExperimentScripting,
  isFinalStep,
  messages,
  onClickBack,
  onClickCancel,
  onClickForward,
  stepNumber
}) => {
  const classString = classNames({
    'vra-manual-script': true,
    'vra-route-container': true,
    'vra-route-container--script-flow': true,
    'vra-route-container--manual': true,
    'vra-route-container--app-mode': isAppMode
  });
  const Content = steps[stepNumber];

  return (
    <LoadingWrapperContainer initialLoadIsInProgress={initialLoadIsInProgress || stepNumber === 0}>
      <section className={classString}>
        <MessagePanel
          closeMessage={closeMessage}
          isToolbarShown={false}
          messages={messages}
        />
        <ScriptFlowHeader
          isVisible={!isAppMode}
          onClickCancel={() => onClickCancel(stepNumber)}
        />
        <ScriptFlowBody
          canGoBack={canGoBack}
          canGoForward={canGoForward}
          isAppMode={isAppMode}
          isExperimentScripting={isExperimentScripting}
          isFinalStep={isFinalStep}
          onClickBack={onClickBack}
          onClickForward={onClickForward}>
          <Content />
        </ScriptFlowBody>
        <QuitFlowModalContainer />
      </section>
    </LoadingWrapperContainer>
  );
};

TrialScript.propTypes = {
  canGoBack: propTypes.bool.isRequired,
  canGoForward: propTypes.bool.isRequired,
  closeMessage: propTypes.func.isRequired,
  initialLoadIsInProgress: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isExperimentScripting: propTypes.bool,
  isFinalStep: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired,
  onClickBack: propTypes.func.isRequired,
  onClickCancel: propTypes.func.isRequired,
  onClickForward: propTypes.func.isRequired,
  stepNumber: propTypes.number.isRequired
};

export default TrialScript;
